export default "./images/survio-3S38y-assets-reference-de.png";